module.exports = __webpack_public_path__ + "static/media/Hindi_Mallika BG-12.866d9a17.png";